export const PRIMARY_COLOR = "#7DCD85";
export const SECONDARY_COLOR = "#132B64";
export const NEUTRAL_COLOR = "#504F4F";